var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailErrorAlertNotificationWarningSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "254px",
    height: "254px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#004d21",
    stroke: "#004d21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1fb731;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.91,53.91a5.93,5.93,0,0,1-4.24-1.76l-4.32-4.32A2,2,0,0,1,42.17,45l4.33,4.32a2,2,0,0,0,2.82,0,2,2,0,0,0,0-2.82L36.24,33.41a2,2,0,0,1,0-2.82L49.32,17.5a2,2,0,0,0,0-2.82,2,2,0,0,0-2.82,0L33.41,27.76a2,2,0,0,1-2.82,0L17.5,14.68a2,2,0,0,0-2.82,0,2,2,0,0,0,0,2.82L27.76,30.59a2,2,0,0,1,0,2.82L14.68,46.5a2,2,0,0,0,0,2.82,2,2,0,0,0,2.82,0L30.59,36.24a2,2,0,0,1,2.82,0l2.44,2.44A2,2,0,0,1,33,41.51l-1-1L20.33,52.15a6,6,0,1,1-8.48-8.48L23.51,32,11.85,20.33a6,6,0,1,1,8.48-8.48L32,23.51,43.67,11.85a6,6,0,1,1,8.48,8.48L40.49,32,52.15,43.67a6,6,0,0,1-4.24,10.24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailErrorAlertNotificationWarningSvgrepoCom);
export default __webpack_public_path__ + "static/media/fail-error-alert-notification-warning-svgrepo-com.19876a9379bf542c88022503ac0069f5.svg";
export { ForwardRef as ReactComponent };